import VueI18n from '../../../i18n/i18n'

let that
let get_this = function(num){
  that = num
}

let custom = function (rule, value, callback) {
  // console.log(rule.field)
  // console.log(value)
	if (value) {
		
	}else{
		
	}
}

let rules = {
	nickname: [
		{ required: true, message: VueI18n.t('EditPersonalInformation.rules.nickname_required'), trigger: "blur" },
		{ minlength: 1, maxlength: 50, message: VueI18n.t('EditPersonalInformation.rules.nickname_length'), trigger: "blur" }
	],
	avatar: [
		{ required: true, message: VueI18n.t('EditPersonalInformation.rules.avatar_required'), trigger: "change" },
		// { validator: custom, trigger: 'change' }
	],
	bg_img: [
		{ required: true, message: VueI18n.t('EditPersonalInformation.rules.bg_img_required'), trigger: "change" },
	],
}

export { rules, get_this }
